// extracted by mini-css-extract-plugin
module.exports = {"LeverandoerListe":"LeverandoerListe_LeverandoerListe__1kF5P","EmptyList":"LeverandoerListe_EmptyList__MXSKO"};